export type TypeMessageAlert = {
  message: string
  class: string
  errors: string[]
}

export const messageAlert: TypeMessageAlert = {
  message: '',
  class: '',
  errors: []
}
